import type { SVGProps } from 'react';
export const Piechart = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M6.5 3.94A7 7 0 0 1 10 3a.7.7 0 0 1 .68.68V9.6l5.13 2.96c.32.19.43.6.26.91l-.03.06a7 7 0 1 1-9.53-9.6m8.01 9.45-4.84-2.8h-.02l-4.84-2.8a5.65 5.65 0 0 0 9.7 5.6M5.5 6.61l3.83 2.22V4.4A5.7 5.7 0 0 0 5.5 6.6m6.23-3.12q.28-.2.61-.09a7 7 0 0 1 4.55 7.88.68.68 0 0 1-1 .47l-4.11-2.38a.7.7 0 0 1-.34-.59V4.04c0-.22.1-.43.29-.55m1.06 1.6v3.3l2.87 1.66V10a5.6 5.6 0 0 0-2.87-4.91"
      clipRule="evenodd"
    />
  </svg>
);
